import { render, staticRenderFns } from "./DynamicPatientInfoForm.vue?vue&type=template&id=62a8cb6f&scoped=true"
import script from "./DynamicPatientInfoForm.vue?vue&type=script&lang=js"
export * from "./DynamicPatientInfoForm.vue?vue&type=script&lang=js"
import style0 from "./DynamicPatientInfoForm.vue?vue&type=style&index=0&id=62a8cb6f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62a8cb6f",
  null
  
)

export default component.exports